import { Component, OnInit, Input, AfterViewInit, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, ElementRef, ViewChild, ViewChildren, QueryList, NgZone } from '@angular/core';
//import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { DirDetailsService } from 'src/app/modules/directory/services/dir-details.service';
import { FeedService } from '../../services/feed.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { LoginService } from 'src/app/core/services/login.service';
import { FeedImageComponent } from '../feed-image/feed-image.component';
import { CommonService } from '../../services/common.service';
import { LikedUsersPopupComponent } from '../liked-users-popup/liked-users-popup.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FeedVideoComponent } from '../feed-video/feed-video.component';
import { AddNewsfeedPopupComponent } from '../add-newsfeed-popup/add-newsfeed-popup.component';
import { BehaviorSubject } from 'rxjs';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { ClassGetter } from '@angular/compiler/src/output/output_ast';
import { EditCommentDialogComponent } from '../edit-comment-dialog/edit-comment-dialog.component';
import { FeedDocumentComponent } from '../feed-document/feed-document.component';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { take } from 'rxjs/operators';
import { DocumentViewerComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component';


@Component({
  selector: 'app-single-feed',
  templateUrl: './single-feed.component.html',
  styleUrls: ['./single-feed.component.scss'],
  animations: [
    trigger('openCloseStatus', [
      state('open', style({ height: '*', opacity: 1 })),
      state('closed', style({ height: '0px', opacity: 0 })),
      transition('open <=> closed', [animate('300ms ease-in-out')])
    ])
  ]
})
export class SingleFeedComponent implements OnInit, AfterViewInit {
  @Input() feed: any;
  @ViewChild('commentSection') commentSection!: ElementRef;
  @Input() selectedCategory: any;
  @Input() selectedUser: any;
  @Input() selectedCompany: any;
  @Input() commentShows: any;
  @ViewChild('commentInput') commentInput!: ElementRef;
  @ViewChildren('replyInput') replyInputs!: QueryList<ElementRef>;

  isLiked: boolean = false;
  likedUsersData$ = new BehaviorSubject<any[]>([]);
  likedUsersData = []
  feedStatus = false;
  commentShow = false;
  commentForm: FormGroup;
  newsfeedsComments: any;
  newsfeeds: any;
  userComment: any;
  loginDetails: any;
  feedIndexUnlike: any;
  count: any;
  business: any;
  likedUsersList: { id: string; name: string }[] = [];
  visibleUsers: { id: string; name: string }[] = [];
  showTooltip: boolean = false;
  showAllUsers: boolean = false;
  showCommentsTooltip: boolean = false;
  showAllCommentUsers: boolean = false;
  hideTimeout: any;
  commentStatus = false;
  maxVisibleUsers: number = 4;
  maxVisibleCommentUsers: number = 5;
  tooltipMessage: string = 'No comments yet';
  comentedUserList: { id: string; name: string }[] = [];
  visibleCommentUsers: { id: string; name: string }[] = [];
  newsfeedsCommentsReplys: any;
  commentCount: any;
  likeUser: any;
  attachedFiles: any;
  imageObject: any;
  commentedUsersList: any[];
  isReplyVisible = false;
  commentsDetails: any = [];
  catalogueData: any;

  // Frontend URL (Angular page for humans)
  frontendBaseUrl = 'https://di360-ba1d7.web.app/prelogin';
  // Backend URL (for OG meta tags / bots)
  backendBaseUrl = 'https://api.dentalinterface.com/api/v1/prelogin';
  canEditOrDelete(comment: any): boolean {
    return this.isCommentOwner(comment) || this.isAdmin();
  }

  isCommentOwner(comment: any): boolean {
    return [
      comment?.dental_admin_id,
      comment?.dental_practice_id,
      comment?.dental_supplier_id,
      comment?.dental_professional_id
    ].includes(this.loginDetails?.id);
  }

  isAdmin(): boolean {
    return this.loginDetails.type === 'ADMIN';
  }

  showPopup = false;

  openPopup() {


    this.showPopup = true;
    this.commentShow = true;
    this.showCommentsTooltip = false;

    //  document.body.style.overflow = 'hidden';
    // Use setTimeout to ensure the element is rendered
    setTimeout(() => {
      this.commentInput?.nativeElement?.focus();
    }, 0);

    this.commentShow = true;
    this.removeReply();

    // Trigger change detection to ensure the input is rendered
    this.cdr.detectChanges();

    // Wait until Angular stabilizes (DOM is fully updated)
    this.zone.onStable.pipe(take(1)).subscribe(() => {
      if (this.commentInput?.nativeElement) {
        this.commentInput.nativeElement.focus();
      }
    });

  }

  closePopup() {
    this.showPopup = false;
    this.showCommentsTooltip = false;
    document.body.style.overflow = 'auto'; // Restore scrolling
  }

  addLikes = {
    dental_practice_id: null,
    dental_professional_id: null,
    dental_supplier_id: null,
    news_feeds_id: null,
    dental_admin_id: null,
    jobs_id: null,
    course_id: null
  }
  addCommentsData = {
    id: null,
    dental_practice_id: null,
    dental_professional_id: null,
    dental_supplier_id: null,
    news_feeds_id: null,
    jobs_id: null,
    course_id: null,
    comments: null,
    dental_admin_id: null,
    comment_Pro_Img: null,
    commenter_name: null,
    comments_attachments: null,
  }


  addReplyData = {
    dental_practice_id: null,
    dental_professional_id: null,
    dental_supplier_id: null,
    news_feeds_id: null,
    reply_text: null,
    dental_admin_id: null,
    comment_id: null,
    reply_id: null,
    liked_count: 0,
    reply_attachments: null,
    jobs_id: null,
    course_id: null
  }
  addReplyedData = {
    dental_practice: null,
    id: null,
    admin_user: null,
    dental_professional: null,
    dental_supplier: null,
    news_feeds_id: null,
    reply_text: null,
    dental_admin_id: null,
    __typename: null,
    comment_id: null,
    reply_id: null,
    liked_count: 0,
    reply_attachments: null
  }

  favoriteStatus = false;
  feedIndex: any;
  userData: any;
  userFollowing: any;
  followingIds = [];
  followersIds = [];
  userFollowers: any;
  isEditMode = false;

  @Output() feedStatusChanged = new EventEmitter<Boolean>();
  @Output() UpdateFeed = new EventEmitter<Boolean>();
  activeReplyIndex: number | null = null;

  visibleReplies: Set<number> = new Set();

  replyText: string = '';
  userName: any;
  constructor(private feedService: FeedService, private commonService: CommonService, private _fb: FormBuilder, private loginService: LoginService, private toast: ToastService, private _dialog: MatDialog, private router: Router, private dirService: DirDetailsService, private spinner: NgxSpinnerService, private cdr: ChangeDetectorRef, private dialog: MatDialog, private mediaService: MediaService, private zone: NgZone) { }

  ngOnInit(): void {


    this.commentShow = this.commentShows;
    this.getReplies();
    this.profileImageUrl = this.loginDetails?.logo?.url;
    this.updateCommentCount();
    this.loginDetails = this.loginService.getLoginData()
    this.commentForm = this._fb.group({
      comment: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],

    });

    if (this.feed?.feed_type === 'CATALOGUE') {
      const catalogueId = this.feed.payload?.catalogue_id;
      if (catalogueId) {
        this.feedService.getCataloguesByIds([catalogueId]).subscribe(
          (catalogues: any[]) => {
            this.catalogueData = catalogues[0] || null;
          },
          error => console.error('Error loading catalogue:', error)
        );
      }
    }

    this.catalogueValue = this.selectedCategory?.category_name?.toLowerCase() === 'catalog' ? 'CATALOGUE' : null;

    if (this.catalogueValue === this.feed?.feed_type) {
      this.catalogue = true
    }
    this.cdr.detectChanges();

  }


  isCatalogueExpired(): boolean {
    if (!this.catalogueData?.expiryDay) return false;
    const expiry = new Date(this.catalogueData.expiryDay);
    const today = new Date();

    expiry.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return expiry < today;
  }

  getReplies() {

    this.commentsDetails = this.feedService.transformToHierarchy(this.feed?.news_feeds_comments);

  }


  approveNewsfeed(feedId: string) {
    this.feedService.updateNewsfeedStatus(feedId, 'PUBLISHED').then((res: any) => {
      if (res) {
        this.feedStatusChanged.emit(true);
        this.toast.openSnackBar('Newsfeed published successfully');
      }
    });
  }
  approveJob(feedId: string) {
    this.feedService.updateJobStatus(feedId, 'PUBLISHED').then((res: any) => {
      if (res) {
        this.feedStatusChanged.emit(true);
        this.toast.openSnackBar('Job published successfully');
      }
    });
  }
  approveLearningHub(feedId: string) {
    this.feedService.updateLaerningHub(feedId, 'PUBLISHED').then((res: any) => {
      if (res) {
        this.feedStatusChanged.emit(true);
        this.toast.openSnackBar('Learning Hub published successfully');
      }
    });
  }
  rejectNewsfeed(feedId: string) {
    this.feedService.updateNewsfeedStatus(feedId, 'UNPUBLISHED').then((res: any) => {
      if (res) {
        this.feedStatusChanged.emit(true);
        this.toast.openSnackBar('Newsfeed successfully unpublished');
      }
    });
  }
  rejectJob(feedId: string) {
    this.feedService.updateJobStatus(feedId, 'UNPUBLISHED').then((res: any) => {
      if (res) {
        this.feedStatusChanged.emit(true);
        this.toast.openSnackBar('Job successfully unpublished');
      }
    });
  }
  rejectlearnHub(feedId: string) {
    this.feedService.updateLaerningHub(feedId, 'UNPUBLISHED').then((res: any) => {
      if (res) {
        this.feedStatusChanged.emit(true);
        this.toast.openSnackBar('Job successfully unpublished');
      }
    });
  }
  deleteNewsfeed(feedId: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: feedId,
        name: "NewsFeed"
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes') {
        this.feedStatusChanged.emit(true);
        this.feedService.deleteNewsfeed(feedId).then(() => {
          this.toast.openSnackBar('Newsfeed deleted successfully');
        });
      }
    });
  }
  deleteJob(feedId: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: feedId,
        name: "jobs"
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes') {
        this.feedStatusChanged.emit(true);
        this.feedService.deleteJob(feedId).then(() => {
          this.toast.openSnackBar('Newsfeed deleted successfully');

        });
      }
    });
  }
  deleteLearnHub(feedId: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: feedId,
        name: "learnHub"
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes') {
        this.feedStatusChanged.emit(true);
        this.feedService.deleteLearnHub(feedId).then(() => {
          this.toast.openSnackBar('Newsfeed deleted successfully');

        });
      }
    });
  }

  deleteComment(commentId: any) {


    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: commentId.id,
        name: 'Comment'
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes') {
        // this.feedStatusChanged.emit(true);
        this.feedService.deleteNewsfeedComments(commentId.id).then(() => {
          this.toast.openSnackBar(' Comment deleted successfully');

          let likedsec = 'Send';
          // let feedID = commentId?.jobs ? commentId?.jobs.id : commentId?.newsfeed.id;
          let feedID = commentId?.jobs?.id
            ?? commentId?.newsfeed?.id
            ?? commentId?.courses?.id;

          // let feedType = commentId?.jobs ? "JOBS" : "feed";
          let feedType = commentId?.jobs ? "JOBS" :
            commentId?.newsfeed ? "feed" :
              commentId?.courses ? "LEARNHUB" :
                null;

          this.updateCommentCount();

          this.getLikedUserData(feedID, likedsec, feedType);

        });

      }
    });
  }

  editComment(comment: any) {
    const dialogRef = this.dialog.open(EditCommentDialogComponent, {
      width: '400px',
      data: {
        comment: comment.comments, id: comment.id, feed: this.feed, comments_attachments: comment.comments_attachments
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        comment.comments = result.comments;
        comment.comments_attachments = result.comments_attachments;
      }

    });
  }

  limit: number;
  offset: number;
  getNewsFeed() {
    this.feedService.getNewsFeeds(this.feed.status, this.limit, this.offset).subscribe(data => {
      this.newsfeeds = data;
    });

  }

  handleFeedStatusChange(feedData: Boolean) {
    this.feedStatusChanged.emit(true);

  }
  getNewsFeedComments() {
    this.feedService.getNewsFeeds(this.feed.status, this.limit, this.offset).subscribe(data => {
      this.newsfeedsComments = data.news_feeds_comments;
    });

  }

  replyAttachSelectedFiles: any[] = [];

  replyFileSelected(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file: File) => {
      const formData = new FormData();
      formData.append('directory', 'project');
      formData.append('file', file);
      this.mediaService.uploadMedia(formData).subscribe(response => {
        if (response && response.url) {
          this.replyAttachSelectedFiles.push({
            name: file.name,
            type: file.type,
            url: response.url,
          });
        }

      }, error => {
        console.error("Upload failed:", error);
      });
    });

    event.target.value = '';
  }

  replyRemoveFile(index: number) {
    this.replyAttachSelectedFiles.splice(index, 1);
  }

  commentAttachSelectedFiles: any[] = [];

  commentFileSelected(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file: File) => {

      const formData = new FormData();
      formData.append('directory', 'project');
      formData.append('file', file);
      this.mediaService.uploadMedia(formData).subscribe(response => {
        if (response && response.url) {
          this.commentAttachSelectedFiles.push({
            name: file.name,
            type: file.type,
            url: response.url,
          });
        }

      }, error => {
        console.error("Upload failed:", error);
      });
    });

    event.target.value = '';
  }

  removeFile(index: number) {
    this.commentAttachSelectedFiles.splice(index, 1);
  }


  getNewsFeedCommentsReplys() {

    this.getNewsFeed();

    this.feedService.getNewsFeeds(this.feed.status, this.limit, this.offset).subscribe(data => {
      data.map((res: any) => {
        this.newsfeedsCommentsReplys = res.news_feeds_comments
      });

    });
  }

  async sendReply(comment, feedReply) {

    if (!this.replyText || !this.replyText.trim()) {
      this.toast.openSnackBar("Please enter valid reply");
      return;
    }

    this.visibleReplies.clear();
    this.isReplyVisible = false;
    const type = this.loginDetails.type;
    const id = this.loginDetails.id;

    if (this.loginDetails.type === "PROFESSIONAL") {
      this.addReplyData.dental_professional_id = this.loginDetails.id;
    }
    if (this.loginDetails.type === "SUPPLIER") {
      this.addReplyData.dental_supplier_id = this.loginDetails.id;
    }
    if (this.loginDetails.type === "PRACTICE") {
      this.addReplyData.dental_practice_id = this.loginDetails.id;
    }
    if (this.loginDetails.type === "ADMIN") {
      this.addReplyData.dental_admin_id = this.loginDetails.id;
    }


    // if (type === "PROFESSIONAL") this.addReplyData.dental_professional_id = id;
    // else if (type === "SUPPLIER") this.addReplyData.dental_supplier_id = id;
    // else if (type === "PRACTICE") this.addReplyData.dental_practice_id = id;
    // else if (type === "ADMIN") this.addReplyData.dental_admin_id = id;

    this.addReplyData.reply_text = `${this.userName} ${this.replyText}`;
    this.addReplyData.news_feeds_id = (feedReply.feed_type === null || feedReply.feed_type === "CATALOGUE") ? feedReply.id : null;
    this.addReplyData.jobs_id = feedReply.feed_type === "JOBS" ? feedReply.id : null;
    this.addReplyData.course_id = feedReply.feed_type === "LEARNHUB" ? feedReply.id : null;
    this.addReplyData.reply_attachments = this.replyAttachSelectedFiles;

    const statusData = await this.feedService.addNewsfeedCommentsReplys(this.addReplyData);
    let likedsec = 'Send';

    this.getLikedUserData(feedReply.id, likedsec, feedReply.feed_type);
  }

  toggleReply(commentIndex: number, comment: any) {
    this.isReplyVisible = true;
    this.activeReplyIndex = commentIndex;

    if (comment?.dental_practice) {
      this.userName = `@${comment.dental_practice.name}`;
    } else if (comment?.dental_professional) {
      this.userName = `@${comment.dental_professional.name}`;
    } else if (comment?.dental_supplier) {
      this.userName = `@${comment.dental_supplier.name}`;
    } else if (comment?.admin_user) {
      this.userName = `@DentalInterface`;
    }

    this.addReplyData.comment_id = comment.id;
    this.addReplyData.reply_id = comment.id;
    this.replyText = '';
    this.replyAttachSelectedFiles = [];

    const alreadyVisible = this.visibleReplies.has(commentIndex);

    // If not already visible, make visible
    if (!alreadyVisible) {
      this.visibleReplies.clear();
      this.visibleReplies.add(commentIndex);
      this.cdr.detectChanges();
    }

    // Always try focusing after DOM is stable
    setTimeout(() => {
      const inputsArray = this.replyInputs.toArray();
      const replyInput = inputsArray[commentIndex];
      if (replyInput) {
        replyInput.nativeElement.focus();
      }
    }, 0);
  }

  removeReply() {
    this.isReplyVisible = false;
  }

  showcomment(): void {
    this.commentShow = true;
    this.removeReply();

    // Trigger change detection to ensure the input is rendered
    this.cdr.detectChanges();

    // Wait until Angular stabilizes (DOM is fully updated)
    this.zone.onStable.pipe(take(1)).subscribe(() => {
      if (this.commentInput?.nativeElement) {
        this.commentInput.nativeElement.focus();
      }
    });
  }

  focusCommentInput(inputElement: HTMLInputElement): void {
    this.commentShow = true;
    this.removeReply();

  }

  toggleReplyed(commentIndex: number, comment: any) {

    this.isReplyVisible = true;

    if (this.visibleReplies.has(commentIndex)) {
      // this.visibleReplies.delete(commentIndex);
      return;
    }

    // Set username
    if (comment?.dental_practice) {
      this.userName = `@${comment.dental_practice.name}`;
    } else if (comment?.dental_professional) {
      this.userName = `@${comment.dental_professional.name}`;
    } else if (comment?.dental_supplier) {
      this.userName = `@${comment.dental_supplier.name}`;
    } else if (comment?.admin_user) {
      this.userName = '@DentalInterface';
    }

    // Reset reply state
    this.addReplyData.comment_id = comment.comment_id;
    this.addReplyData.reply_id = comment.id;
    this.replyText = '';
    this.replyAttachSelectedFiles = [];

    this.visibleReplies.clear();
    this.visibleReplies.add(commentIndex);

    // Force change detection
    this.cdr.detectChanges();

    //  Let Angular finish rendering before focusing
    this.zone.onStable.pipe().subscribe(() => {
      const inputsArray = this.replyInputs.toArray();
      const replyInput = inputsArray[commentIndex];

      if (replyInput) {
        replyInput.nativeElement.focus();
      }
      // else {
      //   console.warn('No reply input found at index:', commentIndex);
      // }
    });
  }

  handleEnter(event: KeyboardEvent, comment: any, feedId: any) {

    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendReply(comment, feedId);
    }
  }


  openDialog(feedId: string) {
    const dialog = this.dialog.open(AddNewsfeedPopupComponent, {
      width: '40%',
      panelClass: ['custom-modal'],
      data: feedId
    });
    dialog.afterClosed().subscribe((responce) => {

      if (responce) {
        this.feedStatusChanged.emit(true);
      }
    });
  }
  catalogue: boolean = false
  catalogueValue = ''
  profileImageUrl = ''


  handleComments(event: any) {
    this.userComment = event.target.value

  }

  goToDetails(business: any) {

    this.router.navigate(['/directory/directory-details', business.id], { state: { business } });
  }

  @ViewChildren('nestedReplies') nestedReplies!: QueryList<ElementRef>;


  ngAfterViewInit() {
    this.loginDetails = this.loginService.getLoginData()
    for (let one of this.feed.newsfeeds_likes) {
      if (this.loginDetails.type == "PROFESSIONAL") {
        if (this.loginDetails.id == one.dental_professional?.id) {
          this.feed.liked = true
        }
      } else if (this.loginDetails.type == "PRACTICE") {
        if (this.loginDetails.id == one.dental_practice?.id) {
          this.feed.liked = true
        }
      }
      else if (this.loginDetails.type == "ADMIN") {
        if (this.loginDetails.id == one.dental_admin_id) {
          this.feed.liked = true
        }
      } else {
        if (this.loginDetails.id == one.dental_supplier?.id) {
          this.feed.liked = true
        }
      }

    }

    setTimeout(() => {
      this.nestedReplies.forEach((ref, index) => {
        const height = ref.nativeElement.offsetHeight;
        const node = ref.nativeElement.closest('.reply-node');
        if (node) {
          node.style.setProperty('--line-height', `${height}px`);
        }
      });
    });

    this.cdr.detectChanges();
  }
  get comment(): AbstractControl {
    return this.commentForm.get('comment');
  }

  updateCommentCount() {
    this.commentCount = this.feed?.news_feeds_comments?.length || 0;
  }
  showComments() {
    this.commentShow = !this.commentShow;
    this.isReplyVisible = false;
    this.updateCommentCount();

  }
  showshare() {
  }


  getLikedUserData(feedId: any, likeValue: any, feedType) {
    console.log("feedId", feedId)

    // get jobs comments
    if (feedType === 'JOBS')
      this.feedService.getNewsFeedIdDatajobs(feedId).subscribe((res) => {

        if (likeValue === 'Send') {
          this.commentsDetails = res[0]?.news_feeds_comments?.sort((a, b) => {
            return (
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
            );
          });
          this.commentsDetails = this.feedService.transformToHierarchy(
            res[0]?.news_feeds_comments
          );

          this.commentCount = this.commentsDetails?.length || 0;


        } else {
          let updatedData: { id: string; name: string; type: string }[] = [];
          for (let value of res) {
            for (let single of value.newsfeeds_likes) {
              if (single.dental_practice) {
                updatedData.push({
                  id: single.dental_practice.id,
                  name: single.dental_practice.name,
                  type: single.dental_practice.type,
                });
              } else if (single.dental_professional) {
                updatedData.push({
                  id: single.dental_professional.id,
                  name: single.dental_professional.name,
                  type: single.dental_professional.type,
                });
              } else if (single.dental_supplier) {
                updatedData.push({
                  id: single?.dental_supplier.id,
                  name: single?.dental_supplier.name,
                  type: single?.dental_supplier.type,
                });
              } else if (single.dental_admin_id) {
                updatedData.push({
                  id: single.admin_user.id,
                  name: single.admin_user.name,
                  type: single.admin_user.type,
                });
              }
            }
          }

          this.likedUsersList = updatedData;

          this.visibleUsers = this.likedUsersList.slice(
            0,
            this.maxVisibleUsers
          );
          // this.showTooltip = true;
        }
      });

    // get learnhub comments
    else if (feedType === 'LEARNHUB')
      this.feedService.getNewsfeedIdDataCourses(feedId).subscribe((res) => {


        if (likeValue === 'Send') {
          this.commentsDetails = res[0]?.news_feeds_comments?.sort((a, b) => {
            return (
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
            );
          });
          this.commentsDetails = this.feedService.transformToHierarchy(
            res[0]?.news_feeds_comments
          );

          this.commentCount = this.commentsDetails?.length || 0;


        } else {
          let updatedData: { id: string; name: string; type: string }[] = [];
          for (let value of res) {
            for (let single of value.newsfeeds_likes) {
              if (single.dental_practice) {
                updatedData.push({
                  id: single.dental_practice.id,
                  name: single.dental_practice.name,
                  type: single.dental_practice.type,
                });
              } else if (single.dental_professional) {
                updatedData.push({
                  id: single.dental_professional.id,
                  name: single.dental_professional.name,
                  type: single.dental_professional.type,
                });
              } else if (single.dental_supplier) {
                updatedData.push({
                  id: single?.dental_supplier.id,
                  name: single?.dental_supplier.name,
                  type: single?.dental_supplier.type,
                });
              } else if (single.dental_admin_id) {
                updatedData.push({
                  id: single.admin_user.id,
                  name: single.admin_user.name,
                  type: single.admin_user.type,
                });
              }
            }
          }

          this.likedUsersList = updatedData;

          this.visibleUsers = this.likedUsersList.slice(
            0,
            this.maxVisibleUsers
          );
          // this.showTooltip = true;
        }
      });

    // get newsfeed and catalogue commnets
    else {
      // my previous
      this.feedService.getNewsFeedIdData(feedId).subscribe((res) => {

        if (likeValue === 'Send') {
          this.commentsDetails = res[0]?.news_feeds_comments?.sort((a, b) => {
            return (
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
            );
          });
          this.commentsDetails = this.feedService.transformToHierarchy(
            res[0]?.news_feeds_comments
          );
          this.commentCount = this.commentsDetails?.length || 0;

        } else {
          let updatedData: { id: string; name: string; type: string }[] = [];
          for (let value of res) {
            for (let single of value.newsfeeds_likes) {
              if (single.dental_practice) {
                updatedData.push({
                  id: single.dental_practice.id,
                  name: single.dental_practice.name,
                  type: single.dental_practice.type,
                });
              } else if (single.dental_professional) {
                updatedData.push({
                  id: single.dental_professional.id,
                  name: single.dental_professional.name,
                  type: single.dental_professional.type,
                });
              } else if (single.dental_supplier) {
                updatedData.push({
                  id: single?.dental_supplier.id,
                  name: single?.dental_supplier.name,
                  type: single?.dental_supplier.type,
                });
              } else if (single.dental_admin_id) {
                updatedData.push({
                  id: single.admin_user.id,
                  name: single.admin_user.name,
                  type: single.admin_user.type,
                });
              }
            }
          }

          this.likedUsersList = updatedData;

          this.visibleUsers = this.likedUsersList.slice(
            0,
            this.maxVisibleUsers
          );
          // this.showTooltip = true;
        }
      });
    }


  }
  async newsLikes(feedData) {

    console.log("feedData for newsLikes", feedData)

    this.likeUser = feedData;
    if (this.loginDetails.type === "PROFESSIONAL") {
      this.addLikes.dental_professional_id = this.loginDetails.id;
    } else if (this.loginDetails.type === "SUPPLIER") {
      this.addLikes.dental_supplier_id = this.loginDetails.id;
    } else if (this.loginDetails.type === "PRACTICE") {
      this.addLikes.dental_practice_id = this.loginDetails.id;
    }
    else if (this.loginDetails.type === "ADMIN") {
      this.addLikes.dental_admin_id = this.loginDetails.id;
    }
    this.addLikes.news_feeds_id = (feedData.feed_type === null || feedData.feed_type === "CATALOGUE") ? feedData.id : null;
    this.addLikes.jobs_id = feedData.feed_type === "JOBS" ? feedData.id : null;
    this.addLikes.course_id = feedData.feed_type === "LEARNHUB" ? feedData.id : null;

    await this.feedService.addNewsfeedsLikes(this.addLikes);
    feedData.liked = true;
    feedData.newsfeeds_likes_aggregate.aggregate.count += 1;


    //  also update local list immediately
    feedData.newsfeeds_likes.push({
      dental_professional: this.loginDetails.type === "PROFESSIONAL" ? { ...this.loginDetails } : null,
      dental_practice: this.loginDetails.type === "PRACTICE" ? { ...this.loginDetails } : null,
      dental_supplier: this.loginDetails.type === "SUPPLIER" ? { ...this.loginDetails } : null,
      admin_user: this.loginDetails.type === "ADMIN" ? { ...this.loginDetails } : null
    });

    this.commonService.publish('call-back');
    let likedsec = 'Liked';
    this.getLikedUserData(feedData.id, likedsec, feedData.feed_type);
  }

  async unlike(feedData) {
    await this.feedService.removeNewsLikes(this.loginDetails.id, feedData.id);
    feedData.liked = false;
    feedData.newsfeeds_likes_aggregate.aggregate.count -= 1;


    //  also remove from local list
    feedData.newsfeeds_likes = feedData.newsfeeds_likes.filter(like => {
      return !(
        (like.dental_professional && like.dental_professional.id === this.loginDetails.id) ||
        (like.dental_practice && like.dental_practice.id === this.loginDetails.id) ||
        (like.dental_supplier && like.dental_supplier.id === this.loginDetails.id) ||
        (like.admin_user && like.admin_user.id === this.loginDetails.id)
      );
    });

    this.commonService.publish('call-back');
    let likedsec = 'Liked';

    this.getLikedUserData(feedData.id, likedsec, 'FeedType');
  }

  navigateTo(feed: any) {
    if (feed.feed_type == "CATALOGUE") {
      this.router.navigate(['/catalogues/details', feed.payload.catelogue_id])
    } else if (feed.feed_type == "DIRECTORY") {
      this.router.navigate(['/directory/directory-details', feed.payload.directory_id])
    } else if (feed.feed_type == "SECOND_HAND_SUPPLY") {
      this.router.navigate(['/second-hand-supplies/details', feed.payload.second_hand_supply_id])
    }
  }
  selectedImages: { [key: number]: string[] } = {};
  handleFileUpload(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
  }

  filterDescriptionStatus(): void {
    this.feedStatus = !this.feedStatus;
  }
  feedImageView(selectedMedia: any, feed: any) {
    const mediaArray = this.getPostImagesAndVideos(feed);

    if (!mediaArray || !Array.isArray(mediaArray)) {
      console.error('Error: mediaArray is not defined or is not an array', mediaArray);
      return;
    }
    const mediaItems = mediaArray
      .filter(item => this.isImage(item) || this.isVideo(item))
      .map(item => ({ url: item?.url, type: this.isImage(item) ? 'image' : 'video' }))
      .filter(item => item.url);

    const selectedIndex = mediaItems.findIndex(item => item.url === selectedMedia?.url);

    if (selectedIndex === -1) {
      console.error('Error: Selected media not found in media array', selectedMedia);
      return;
    }
    // const hasMultipleMedia = mediaItems.length > 1;
    this._dialog.open(FeedImageComponent, {
      width: '65%',
      panelClass: ['custom-modal'],
      data: { mediaItems, selectedIndex }
    });
  }

  feedVideoView(video) {
    if (video) {
      this._dialog.open(FeedVideoComponent, {
        width: '40%',
        panelClass: ['custom-modal'],
        data: video
      })
    }
  }
  feeddocumentView(doc) {
    if (doc) {
      this._dialog.open(FeedDocumentComponent, {
        width: '40%',
        panelClass: ['custom-modal'],
        data: doc
      })
    }
  }
  async postComment(feed, commentClear: any) {


    if (this.commentForm.invalid) {
      this.toast.openSnackBar("Please enter valid comment");
      this.commentForm.markAsTouched();
      return;
    }
    if (this.loginDetails.type === "PROFESSIONAL") {
      this.addCommentsData.dental_professional_id = this.loginDetails.id;
    }
    if (this.loginDetails.type === "SUPPLIER") {
      this.addCommentsData.dental_supplier_id = this.loginDetails.id;
    }
    if (this.loginDetails.type === "PRACTICE") {
      this.addCommentsData.dental_practice_id = this.loginDetails.id;
    }
    if (this.loginDetails.type === "ADMIN") {
      this.addCommentsData.dental_admin_id = this.loginDetails.id;
    }
    this.addCommentsData.news_feeds_id = (feed.feed_type === null || feed.feed_type === "CATALOGUE") ? feed.id : null;
    this.addCommentsData.jobs_id = feed.feed_type === "JOBS" ? feed.id : null;
    this.addCommentsData.course_id = feed.feed_type === "LEARNHUB" ? feed.id : null;
    this.addCommentsData.comments = this.commentForm.value.comment;
    this.addCommentsData.comment_Pro_Img = this.loginDetails?.logo?.url;
    this.addCommentsData.commenter_name = this.loginDetails.name;
    this.addCommentsData.comments_attachments = this.commentAttachSelectedFiles;
    const { id, ...postComment } = this.addCommentsData;


    const statusData = await this.feedService.addNewsfeedComments(postComment);

    if (statusData) {
      this.commentStatus = true;
      this.addCommentsData.id = statusData.id;
      feed?.news_feeds_comments.push({ ...this.addCommentsData });
      this.commentAttachSelectedFiles = [];
      this.commentForm.reset();
      this.updateCommentCount();
      this.cdr.detectChanges();
      let likedsec = 'Send';
      let feedType = feed.feed_type;

      this.getLikedUserData(feed.id, likedsec, feedType);
      setTimeout(() => {
        this.scrollToLatestComment();
      }, 100);
    }
  }

  scrollToLatestComment() {
    if (this.commentSection) {
      this.commentSection.nativeElement.scrollTop = this.commentSection.nativeElement.scrollHeight;
    }
  }

  // likedUsers(feed: any) {



  //   let updatedData: { id: string; name: string; type: string }[] = [];

  //   for (let single of feed.newsfeeds_likes) {
  //     if (single.dental_practice) {
  //       updatedData.push({ id: single.dental_practice.id, name: single.dental_practice.name, type: single.dental_practice.type });
  //     } else if (single.dental_professional) {
  //       updatedData.push({ id: single.dental_professional.id, name: single.dental_professional.name, type: single.dental_professional.type });
  //     } else if (single.dental_supplier) {
  //       updatedData.push({ id: single.dental_supplier.id, name: single.dental_supplier.name, type: single.dental_supplier.type });
  //     } else if (single.dental_admin_id) {
  //       updatedData.push({ id: single.admin_user.id, name: single.admin_user.name, type: single.admin_user.type });
  //     }
  //   }

  //   this.likedUsersList = updatedData;
  //   this.visibleUsers = this.likedUsersList.slice(0, this.maxVisibleUsers);
  //   this.showTooltip = true;
  // }



  likedUsers(feed: any) {

    let updatedData: { id: string | null; name: string; type: string }[] = [];

    for (let single of feed.newsfeeds_likes) {
      let directoryId: string | null = null;
      let name = '';
      let type = '';

      if (single.dental_professional) {
        directoryId = single.dental_professional?.directories?.[0]?.id || null;
        name = single.dental_professional.name;
        type = 'PROFESSIONAL';
      } else if (single.dental_practice) {
        directoryId = single.dental_practice?.directories?.[0]?.id || null;
        name = single.dental_practice.name;
        type = 'PRACTICE';
      } else if (single.dental_supplier) {
        directoryId = single.dental_supplier?.directories?.[0]?.id || null;
        name = single.dental_supplier.name;
        type = 'SUPPLIER';
      } else if (single.admin_user) {
        directoryId = null; // Admin might not have directory
        name = single.admin_user.name;
        type = 'ADMIN';
      }

      updatedData.push({ id: directoryId, name, type });
    }

    // Remove duplicates by directoryId
    this.likedUsersList = Array.from(
      new Map(updatedData.map(item => [item.id, item])).values()
    );

    this.visibleUsers = this.likedUsersList.slice(0, this.maxVisibleUsers);
    this.showTooltip = true;
  }



  showTooltipDelayed() {
    clearTimeout(this.hideTimeout);
    this.showTooltip = true;
  }
  hideTooltipDelayed() {
    this.hideTimeout = setTimeout(() => {
      this.showTooltip = false;
      this.showAllUsers = false;
    }, 50);
  }
  toggleShowMore() {
    this.showAllUsers = !this.showAllUsers;
  }


  getPostImagesAndVideos(feed: any): any[] {
    let mediaFiles: any[] = [];

    if (feed?.post_image) {
      mediaFiles = Array.isArray(feed.post_image) ? feed.post_image : [feed.post_image];
    }

    // JOBS banner
    if (feed?.feed_type === 'JOBS' && feed?.banner_image) {
      mediaFiles.push({
        url: feed.banner_image,
        type: 'image',
        mime_type: 'image/png',
        name: 'job-banner_logo',
        file_id: feed.id,
      });
    }

    // LEARNHUB course banners
    if (feed?.feed_type === 'LEARNHUB' && feed?.course_banner_image) {
      const banners = Array.isArray(feed.course_banner_image)
        ? feed.course_banner_image
        : [feed.course_banner_image];

      mediaFiles.push(
        ...banners.map(banner => ({
          url: banner.url,
          type: 'image',
          mime_type: banner.type || 'image/jpeg',
          name: banner.name,
          file_id: feed.id,
        }))
      );
    }

    // LEARNHUB course banners (videos)
    if (feed?.feed_type === 'LEARNHUB' && feed?.course_banner_video) {
      const videos = Array.isArray(feed.course_banner_video)
        ? feed.course_banner_video
        : [feed.course_banner_video];

      mediaFiles.push(
        ...videos.map(video => ({
          url: video.url,
          type: 'video',
          mime_type: video.type || 'video/mp4',
          name: video.name || 'course-banner-video',
          file_id: feed.id,
        }))
      );
    }

    const validMedia = mediaFiles.filter(media => this.isImage(media) || this.isVideo(media));
    return validMedia;
  }
  //   getPostImagesAndVideos(feed: any): any[] {
  //   let mediaFiles: any[] = [];

  //   // post_image
  //   if (feed?.post_image) {
  //     mediaFiles = Array.isArray(feed.post_image) ? feed.post_image : [feed.post_image];
  //   }

  //   // JOBS banner
  //   if (feed?.feed_type === 'JOBS' && feed?.banner_image) {
  //     mediaFiles.push({
  //       url: feed.banner_image,
  //       type: 'image',
  //       mime_type: 'image/png',
  //       name: 'job-banner_logo',
  //       file_id: feed.id,
  //     });
  //   }

  //   // LEARNHUB course banners
  //     if (feed?.feed_type === 'LEARNHUB' && feed?.course_banner_image) {
  //     console.log('called----------------->')
  //     const banners = Array.isArray(feed.course_banner_image)
  //       ? feed.course_banner_image
  //       : [feed.course_banner_image];

  //     mediaFiles.push(
  //       ...banners.map(banner => {
  //         if (typeof banner === 'string') {
  //           // API gave string URL
  //           return {
  //             url: banner,
  //             type: 'image',
  //             mime_type: 'image/jpeg',
  //             name: 'course-banner',
  //             file_id: feed.id,
  //           };
  //         } else {
  //           // API gave object { url, type, name }
  //           return {
  //             url: banner.url,
  //             type: 'image',
  //             mime_type: banner.type || 'image/jpeg',
  //             name: banner.name || 'course-banner',
  //             file_id: feed.id,
  //           };
  //         }
  //       })
  //     );
  //   }

  //   return mediaFiles.filter(media => this.isImage(media) || this.isVideo(media));
  // }

  get displayedMedia(): any[] {
    const mediaFiles = this.getPostImagesAndVideos(this.feed);
    return mediaFiles.slice(0, 4);
  }


  get remainingCount(): number {
    const mediaFiles = this.getPostImagesAndVideos(this.feed);
    return mediaFiles.length > 4 ? mediaFiles.length - 3 : 0;
  }

  getPostDocuments(feed: any): any[] {
    if (!feed?.post_image) return [];
    let mediaFiles = Array.isArray(feed.post_image) ? feed.post_image : [feed.post_image];
    return mediaFiles.filter(media => this.isDocument(media));
  }

  isImage(media: any): boolean {
    if (!media?.url) return false;
    return (
      media?.type?.includes('image') ||
      media?.mime_type?.includes('image') ||
      /\.(jpeg|jpg|png|gif)$/i.test(media.url)
    );
  }
  isDocument(media: any): boolean {
    if (!media?.url) return false;
    return media?.type?.includes('pdf') || media?.type?.includes('application/msword') || /\.(pdf|doc|docx|xls|xlsx|ppt|pptx)$/i.test(media.url);
  }
  isVideo(media: any): boolean {
    if (!media?.url) return false;
    return media?.type?.includes('video') || /\.(mp4|webm|ogg)$/i.test(media.type);
  }

  toggleLike() {
    if (!this.loginDetails || !this.loginDetails.id) {
      console.error("Error: loginDetails or loginDetails.id is undefined");
      return;
    }

  }

  // fetchCommentedUsers(feed: any) {

  //   console.log('feed--123', feed);


  //   if (!feed?.news_feeds_comments || feed.news_feeds_comments.length === 0) {
  //     console.warn("No comments available");
  //     this.commentedUsersList = [];
  //     this.showCommentsTooltip = false;
  //     return;
  //   }
  //   this.commentedUsersList = feed.news_feeds_comments.map(comment => ({
  //     id: comment.id,
  //     name: comment.commenter_name
  //   }));

  //   this.visibleCommentUsers = this.commentedUsersList.slice(0, this.maxVisibleCommentUsers);
  //   console.log('visibleCommentUsers', this.visibleCommentUsers);

  //   this.showCommentsTooltip = true;
  // }


  fetchCommentedUsers(feed: any) {

    if (!feed?.news_feeds_comments || feed.news_feeds_comments.length === 0) {
      this.commentedUsersList = [];
      this.showCommentsTooltip = false;
      return;
    }

    this.commentedUsersList = feed.news_feeds_comments.map(comment => {
      let directoryId: string | null = null;

      if (comment.dental_professional?.directories?.length > 0) {
        directoryId = comment.dental_professional.directories[0].id;
      } else if (comment.dental_practice?.directories?.length > 0) {
        directoryId = comment.dental_practice.directories[0].id;
      } else if (comment.dental_supplier?.directories?.length > 0) {
        directoryId = comment.dental_supplier.directories[0].id;
      }

      return {
        id: directoryId,
        name: comment.commenter_name
      };
    });

    // Remove duplicates by ID
    this.commentedUsersList = Array.from(
      new Map(this.commentedUsersList.map(item => [item.id, item])).values()
    );

    this.visibleCommentUsers = this.commentedUsersList.slice(0, this.maxVisibleCommentUsers);
    this.showCommentsTooltip = true;
  }

  goToCommentUserDetails(user: any) {
    if (!user?.id) {
      console.warn('Directory ID missing for user:', user);
      return;
    }

    this.router.navigate(['/directory/directory-details', user.id], { state: { user } });
  }





  showCommentsTooltipDelayed() {
    setTimeout(() => {
      this.showCommentsTooltip = true;
    }, 300);

  }

  hideCommentsTooltipDelayed() {
    setTimeout(() => {
      this.showCommentsTooltip = false;
    }, 300);
    this.showAllCommentUsers = false;

  }

  toggleShowMoreComments() {
    this.showAllCommentUsers = !this.showAllCommentUsers;
  }

  // goToCommentUserDetails(user: any) {
  //   console.log('user', user);

  //   this.router.navigate(['/directory/directory-details', user.id], { state: { user } });
  // }

  getFeedDisplayName(feed: any): string {
    if (!feed) return '';

    if (feed.user_role === 'ADMIN') {
      return 'Dental Interface';
    }

    if (feed.feed_type === 'CATALOGUE' || feed.feed_type === 'JOBS' || feed.feed_type === 'LEARNHUB') {
      return feed?.dental_supplier?.directories?.[0]?.company_name || '';
    }

    if (feed.dental_supplier_id && feed.feed_type !== 'CATALOGUE') {
      return feed?.dental_supplier?.name || '';
    }

    if (feed.dental_professional_id) {
      return feed?.dental_professional?.name || '';
    }

    if (feed.dental_practice_id) {
      return feed?.dental_practice?.name || '';
    }

    return '';
  }


  viewallDocuments(document, index: number,): void {
    // document =[...document, ...this.getPostDocuments(this.feed)];
    if (JSON.stringify(document) === JSON.stringify(this.displayedMedia)) {

      const datas1 = this.getPostImagesAndVideos(this.feed);

      document = [...datas1, ...this.getPostDocuments(this.feed)];
    }
    else {
      const datas1 = this.getPostImagesAndVideos(this.feed);

      document = [...this.getPostDocuments(this.feed), ...datas1]
    }

    this._dialog.open(DocumentViewerComponent, {
      width: '70%',
      panelClass: ['custom-modal'],
      data: {
        documents: document,
        initialIndex: index
      }
    });
  }

  viewcommentDocuments(document, index: number,): void {

    this._dialog.open(DocumentViewerComponent, {
      width: '70%',
      panelClass: ['custom-modal'],
      data: {
        documents: document,
        initialIndex: index
      }
    });
  }


  // changes dine by vasanth for prelogin
  selectedFeed: any = null;
  showSharePopup = false;

  toggleSharePopup(feed: any) {
    this.selectedFeed = feed;
    this.showSharePopup = !this.showSharePopup;
  }

  //  Use `this` when referring to class properties
  get backendShareUrl(): string {
    return `${this.backendBaseUrl}/${this.selectedFeed?.id}`;
  }

  get frontendShareUrl(): string {
    return `${this.frontendBaseUrl}/${this.selectedFeed?.id}`;
  }

  //  Copy + notify
  private copyAndNotify(message: string) {
    navigator.clipboard.writeText(this.frontendShareUrl).then(() => {
      alert(message);
    });
  }

  //  WhatsApp Share
  shareWhatsApp() {
    this.copyAndNotify('Link copied! Opening WhatsApp...');
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(this.backendShareUrl)}`;
    window.open(whatsappUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Messenger Share
  shareMessenger() {
    this.copyAndNotify('Link copied! Opening Messenger...');
    const messengerUrl = `https://www.facebook.com/dialog/send?link=${encodeURIComponent(
      this.backendShareUrl
    )}&app_id=YOUR_FACEBOOK_APP_ID&redirect_uri=${encodeURIComponent(
      this.frontendShareUrl
    )}`;
    window.open(messengerUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Facebook Share
  shareFacebook() {
    this.copyAndNotify('Link copied! Opening Facebook...');
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      this.backendShareUrl
    )}`;
    window.open(facebookUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Twitter / X Share
  shareTwitter() {
    this.copyAndNotify('Link copied! Opening X...');
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      this.backendShareUrl
    )}&text=${encodeURIComponent('Check out this post!')}`;
    window.open(twitterUrl, '_blank');
    this.showSharePopup = false;
  }

  //  Just copy link
  copyLink() {
    this.copyAndNotify('Link copied!');
    this.showSharePopup = false;
  }
  shareType: 'NEWSFEEDS';
  shareData: any;

  shareFeed(data: any, event: Event) {
    event.stopPropagation(); // prevent parent click

    this.shareType = 'NEWSFEEDS';
    this.shareData = data;
    this.showSharePopup = true;
  }

}